import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { product } from '../data/ebook';
import { BuyButton } from './BuyButton';
const trust = ['Descarga inmediata', 'Sin suplementos', 'Ingredientes de supermercado'];
export function Hero() {
  return <header className="relative overflow-hidden bg-cream px-5 pb-20 pt-12 sm:px-8 md:pb-28 md:pt-16" data-id="element-101" data-mp="4lywsqa2emfr">
      <div className="mx-auto grid w-full max-w-content items-center gap-12 lg:grid-cols-[1.05fr_1fr] lg:gap-16" data-id="element-102" data-mp="12a0mbehn46w7">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-103" data-mp="xa4ibf8y0fgn">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-sage-dark" data-id="element-104" data-mp="ncgiiawhchrm">
            {product.edition}
          </p>

          <h1 className="mt-6 font-display text-5xl font-light leading-[1.02] tracking-tight text-ink sm:text-6xl lg:text-7xl" data-id="element-105" data-mp="3d2birmcv0tty">
            Vientre Plano
            <br data-id="element-106" data-mp="3j8se7xjcfdo9" />
            Express
            <span className="ml-3 align-middle font-sans text-base font-semibold tracking-normal text-sage-dark sm:text-lg" data-id="element-107" data-mp="3j9u1d0dmvqmc">
              7 días
            </span>
          </h1>

          <p className="mt-7 max-w-xl text-lg leading-relaxed text-muted" data-id="element-108" data-mp="39b4ip5dwy251">
            {product.promise} No es grasa: es aire atrapado, retención e inflamación. Y eso se
            puede soltar en una semana.
          </p>

          <div className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-109" data-mp="30h9eq0oj2hqz">
            <BuyButton data-id="element-110" data-mp="359t0vm1a6l7e">Quiero mi guía por ${product.price}</BuyButton>
            <span className="text-sm text-muted" data-id="element-111" data-mp="2qk3kijkmaamj">
              <span className="line-through" data-id="element-112" data-mp="2qleq8oxmhsga">${product.compareAt}</span>{' '}
              <span className="font-semibold text-ink" data-id="element-113" data-mp="2vjzqupgsee59">${product.price} {product.currency}</span> ·
              guía + 3 bonos
            </span>
          </div>

          <ul className="mt-9 flex flex-wrap gap-x-7 gap-y-3 border-t border-line pt-7" data-id="element-114" data-mp="2lkqxnytqx3jy">
            {trust.map(item => <li key={item} className="flex items-center gap-2 text-sm text-muted" data-id="element-115" data-mp="s2b8o0ipgn67">
                <CheckIcon className="h-4 w-4 text-sage" aria-hidden="true" data-id="element-116" data-mp="nat7pcgomml8" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative" data-id="element-117" data-mp="ia5f4mct1xow">
          <img src={product.coverImage} alt="La guía Vientre Plano Express mostrada en computadora, tablet y celular" className="w-full rounded-lg object-cover" width={1024} height={1024} data-id="element-118" data-mp="161aznetoxe5j" />
          <p className="mt-4 text-center text-xs uppercase tracking-[0.18em] text-muted" data-id="element-119" data-mp="x37b09nes19i">
            PDF digital · Léelo en cualquier dispositivo
          </p>
        </motion.div>
      </div>
    </header>;
}